export const isAdminUser = (user: any | null | undefined) => {
  if (!user) return false;

  const candidates = [
    user?.role,
    user?.user_metadata?.role,
    user?.app_metadata?.role,
    user?.user_metadata?.user_type,
    user?.app_metadata?.user_type,
  ]
    .map((v) => (typeof v === 'string' ? v.trim().toLowerCase() : ''))
    .filter(Boolean);

  return candidates.some((r) => r === 'admin' || r === 'super_admin' || r === 'superadmin');
};

